/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import * as civilServiceLawStages from "../../Stages/StagesCivilServiceLaw";
import { stageMetaDataCivilServiceLaw } from "../../Stages/StagesCivilServiceLaw";
import * as caseStatus from "../../LeadStatus/StatusCase";
import * as caseStages from "../../Stages/StagesCase";
import { stageFormDefinition } from "../FormDefinitions/civilServiceLaw/stageFormDefinition";
import { fullFormDefinition } from "../FormDefinitions/civilServiceLaw/fullFormDefinition";
import { getAdministrativeLitigationLawCaseBadges } from "../Badges/getAdministrativeLitigationLawCaseBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { getProductData } from "./productService";
import { persistCivilServiceLaw } from "../../Persist/CivilServiceLawPersister";
import civilServiceLawTransformations from "../FormTransformations/civilServiceLawTransformations";
import { civilServiceLawDetailsSpecialActions } from "../CaseDetailsSpecialActions/civilServiceLawDetailsSpecialActions";
import { CivilServiceLaw } from "../../../types/Products/AdministrativeLaw/CivilServiceLaw/CivilServiceLaw";

export const civilServiceLaw: ProductData<CivilServiceLaw> = {
  urlPart: "beamtenrecht",
  lbUrlPart: "beamtenrecht",
  label: translate("civilServiceLaw.label"),
  generalLabel: translate("civilServiceLaw.label"),
  apiUri: "civil_service_laws",
  persist: persistCivilServiceLaw,
  stages: stageMetaDataCivilServiceLaw,
  stageConstants: civilServiceLawStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\AdministrativeLaw\\CivilServiceLaw\\CivilServiceLaw",
  formTransformations: civilServiceLawTransformations,
  formDefinition: ({ product }) => stageFormDefinition(product),
  formDefinitionExternals: ({ product }) => stageFormDefinition(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinition(product, currentUser),
  caseDetailsSpecialActions: ({ product }) => civilServiceLawDetailsSpecialActions(product),
  productCategory: "administrativeLaw",
  productSpecificBadges: ({ product }) => getAdministrativeLitigationLawCaseBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.civilServiceLaw,
};
